<div class="row pt-2 pt-md-0 pb-2 pb-md-5 contract-item-container" data-e2e="multi-contracts-options">
  <div class="col-12 col-md-6 col-lg-5">
    <h3 class="mb-0">{{multiContractViewModel?.offerName}}</h3>
    <div class="lead text-gray3">{{multiContractViewModel?.detail}}</div>
  </div>
  <div class="col-12 col-md-6 col-lg-7 mt-1 mt-md-0 btn-center">
    @for (message of multiContractViewModel?.messages; track message) {
    <p class="text-left text-mw">{{message}}</p>
    } @if (multiContractViewModel?.linkInternet || multiContractViewModel.eSimLink) {
    <div class="d-flex justify-content-center justify-content-md-start">
      <div class="d-flex flex-column">
        <a
          class="btn btn-secondary"
          [href]="multiContractViewModel?.linkInternet | link | async"
          (click)="openMultiContract(multiContractViewModel?.linkInternet);false"
          >{{multiContractViewModel.button}}</a
        >
        @if (multiContractViewModel.eSimLink) {
        <a
          class="btn btn-secondary mt-2"
          [href]="multiContractViewModel?.eSimLink | link:getLinkParam() | async"
          (click)="openButtonESimLink();false"
        >
          {{"dashboard.contractsAndOptions.multiContract.parnasse.eSimLabel" | translate}}
        </a>
        }
      </div>
    </div>
    }
  </div>
</div>
